// What differs between the Always Cool sites; the components and site.css are shared.
export const site = {
  name: "Always Cool AI",
  legalName: "Always Cool AI LLC",
  email: "info@alwayscool.ai",
  contact: { href: "/contact", label: "Contact us" },
  footer: [
    {
      title: "Platform",
      links: [
        { href: "/platform", label: "Overview" },
        { href: "/platform/edi", label: "EDI" },
        { href: "/platform/lifecycle", label: "Purchase order lifecycle" },
        { href: "/platform/deductions", label: "Deductions" },
        { href: "/platform/reconciliation", label: "Reconciliation" },
        { href: "/platform/ai-console", label: "AI console" },
      ],
    },
    {
      title: "Company",
      links: [
        { href: "/about", label: "About" },
        { href: "/how-we-work", label: "How we work" },
        { href: "/contact", label: "Contact" },
      ],
    },
    {
      title: "Resources",
      links: [
        { href: "/security", label: "Security" },
        { href: "/docs", label: "Documentation" },
        { href: "/ai-tools", label: "Tools" },
      ],
    },
  ] as { title: string; links: { href: string; label: string }[] }[],
  family: [
    { name: "Always Cool Brands", href: "https://alwayscoolbrands.com" },
    { name: "Always Cool IO", href: "https://alwayscool.io" },
  ] as { name: string; href: string }[],
  menu: {
    label: "Platform",
    href: "/platform",
    items: [
      { href: "/platform/edi", label: "EDI processing", text: "Purchase orders, invoices, and payment advices" },
      { href: "/platform/lifecycle", label: "Purchase order lifecycle", text: "Nine states and three checkpoints" },
      { href: "/platform/deductions", label: "Deduction management", text: "Classified, assigned, and tracked to a close" },
      { href: "/platform/reconciliation", label: "Reconciliation", text: "Quantity, price, and item across every document" },
      { href: "/platform/ai-console", label: "AI console", text: "The same work in plain language" },
    ],
  } as { label: string; href: string; items: { href: string; label: string; text: string }[] } | undefined,
  nav: [
    { href: "/how-we-work", label: "How we work" },
    { href: "/about", label: "About" },
  ],
};
